import { ApiRestService } from '../api-rest.service';
import { Categorie } from '../../Progetti/Models/Categorie';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ActivatedRoute, Router } from '@angular/router';
import {ClassicType} from "../../shared/models/ClassicType";
import {TranslateObj} from "../../shared/models/translatedesc";

@Component({
  selector: 'app-categorie-materiali',
  templateUrl: './categorie.component.html',
  styleUrls: ['./categorie.component.scss']
})
export class CategorieMaterialiComponent implements OnInit {

  categoriedropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    textField: 'categoria',
    idField: 'id',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  sel_cat_id: number = 0;
  type;
  CategoriaDaModificare: Categorie = null;
  LabelCategoria: string = "";
  modificheAbilitate: boolean = false;
  CategorieLineare: Categorie[] = [];
  CategorieSelezionate: Categorie[] = [];
  sidebarnavItems: Categorie[] = []
  _TipoObject: ClassicType;
  CategorieEcommerce: any[] = [];
  CategoriaEcommerceSelezionate: any[] = [];
  transaltedobjects: TranslateObj[];

  constructor(
    private modalService: NgbModal,
    private apirest: ApiRestService,
    public router: Router,
    private route: ActivatedRoute,
  ) {}
  ngOnInit() {
    this.route.params.subscribe(data => {
      console.log(data)
      this.type = data['type'];
      this.sel_cat_id = parseInt(data['cat'] ?? "0") ?? 0;
      this.Reload();
    })
  }
  Reload() {
    // this.apirest.GetCategorieEcommerceList().subscribe(data => this.CategorieEcommerce = data );
    this.apirest.getPartiTypes().subscribe(data => {
      this._TipoObject = data.find(x=> parseInt(x.id.toString()) == parseInt(this.type));
      if(!this._TipoObject) return;
      this.apirest.GetCategorieList(this._TipoObject).subscribe(cat=> this.sidebarnavItems = cat);
      this.apirest.CategorieListList(this._TipoObject,{nome: undefined}).subscribe(cat=> this.CategorieLineare = cat );
    })
  }

  AbilitaModifiche() {
    this.modificheAbilitate =  !this.modificheAbilitate;
  }
  Elimina(value: Categorie){
    if(confirm("Sei sicuro di voler eliminare questa categoria?"))
      this.apirest.DeleteCategorie(this._TipoObject, value).subscribe(() => this.Reload())
  }

  filtroCategoria(item: string) {
    if (item.length >= 3) {
      this.apirest.CategorieListList(this._TipoObject,{nome: undefined}).subscribe(cat=>{
        this.CategorieLineare = cat;
      });
    }
  }
  clicked(cat:Categorie){
    if(isNaN(cat?.id)) return
    this.sel_cat_id = cat.id;
    this.router.navigate([`materiali/list/${this._TipoObject?.id.toString()}/${cat.id.toString()}`]).then();
  }

  openModal(targetModal: NgbModal, selected: Categorie, selectedParent: Categorie) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: 'static'
    });
    this.LabelCategoria =  '';
    this.CategoriaDaModificare = selected ?? new Categorie();
    this.CategorieSelezionate = selectedParent ? [selectedParent] : [];
    // this.apirest.GetCategorieEcommerceList().subscribe(data => this.CategorieEcommerce = data );
    // this.CategoriaEcommerceSelezionate = selected.catsEcObject ?? []
    this.LabelCategoria = selected?.categoria ?? '';
    this.transaltedobjects = selected ? this.gettransaltedobjects(selected): this.createlang(["en", "es", "fr", "de"]);
  }
  createlang(values: string[]): TranslateObj [] {
    var output: TranslateObj [] = [];
    output.push({
      default: true,
      lang: "it",
      TranslateInputs: [ {id: "categoria", label:"Nome Categoria", value: "", type: "text"}]
    })
    values?.forEach(value=>{
      output.push({
        default: false,
        lang: value,
        TranslateInputs: [
          {id: "categoria", label:"Nome Categoria", value: "", type: "text"}
        ]
      })
    })
    return output;
  }

  gettransaltedobjects(item: Categorie): TranslateObj[]{
    return [{
      default: true,
      lang: "it",
      TranslateInputs: [ {id: "categoria", label:"Nome Categoria", value: item?.categoria, type: "text"}]
    }
    ].concat(item?.traduzioni);
  }

  saveModalButton() {
    const updateData = Object.assign({}, this.CategoriaDaModificare);
    updateData.cat_id = this.CategorieSelezionate?.length > 0 ? this.CategorieSelezionate[0]?.id : undefined;
    updateData.traduzioni = this.transaltedobjects?.filter(x => !x?.default)
    if (this.CategoriaDaModificare !== null)
      this.apirest.EditCategorie(this._TipoObject, updateData).subscribe(data => {
        this.Reload();
        this.closeBtnClick()
      });
     else
      this.apirest.AddCategorie(this._TipoObject, updateData).subscribe(data => {
        this.Reload();
        this.closeBtnClick()
      });
  }
  deleteModalButton() {
    const updateData = new Categorie();
    updateData.id = this.CategoriaDaModificare.id;
    if (this.CategorieSelezionate != null && this.CategorieSelezionate.length > 0)
      updateData.cat_id = this.CategorieSelezionate[0].id;
    else
      updateData.cat_id = undefined;
    this.apirest.DeleteCategorie(this._TipoObject, updateData).subscribe(data => {
      this.sel_cat_id = 0;
      this.router.navigate([`materiali/list/${this._TipoObject?.id.toString()}`]).then();
      this.closeBtnClick()
    });
  }

  closeBtnClick() {
    this.modalService.dismissAll();
  }

}
